
import { Options, Vue } from 'vue-class-component'
import DateRangePicker from '@/components/DateRangePicker/DateRangePicker.vue'

import SalesTable from '@/components/SalesTable/SalesTable.vue'
import SalesChart from '@/components/SalesChart/SalesChart.vue'
import StockBind from '@/components/StockBind/StockBind.vue'
import ShowMessage from '@/components/ShowMessage.vue'

import { Http, Urls } from '@/module/http'
// import { Language } from '@/module/language'
import { ResExcelBindData, HTMLInputEvent, ResHomeInfo, ResponseData } from '@/module/response'
import { Tool } from '@/module/tool'
// import { loadMessages } from '@/plugins/i18n'
import DatePicker from 'tui-date-picker'
import { User } from '@/module/user'
import 'tui-date-picker/dist/tui-date-picker.css'

@Options({
  components: {
    DateRangePicker,
    SalesTable,
    SalesChart,
    StockBind,
    ShowMessage,
    DatePicker
  },
  emits: {
    click: null,
    showappmessage: () => {
      return true
    }
  }
})
export default class Home extends Vue {
    tableStartDate: Date = new Date(new Date().setDate(new Date().getDate() - 30))
    tableEndDate: Date = new Date()
    homeInfoData: ResHomeInfo | null = null

    chartCode = ''
    chartAttr = ''
    chartIds: number[] = [];

    excelBindData: ResExcelBindData | null = null;

    messageContent = ''

    mounted () {
      this.initLanguage()
      this.setRangeDate()
      this.updateData()
    }

    updateData () {
      this.initData(this.tableStartDate, this.tableEndDate)
    }

    // async changeLanguage (lang: string) {
    //   await loadMessages(lang)
    // }

    initData (start: Date, end: Date) {
      const data = {
        start: start,
        end: end
      }
      Http.post<ResHomeInfo>(Urls.home_info, data).then((res: ResHomeInfo) => {
        this.homeInfoData = res
      }, (err: ResponseData) => {
        this.showMessage(err.Msg)
      })
    }

    chooseFile () {
      const el = document.getElementById('uploadData')
      if (el != null) {
        el.click()
      }
    }

    download () {
      const startTime = Tool.dateFormat(this.tableStartDate)
      const endTime = Tool.dateFormat(this.tableEndDate)
      window.location.href = Urls.base_url + Urls.home_download + '?start=' + startTime + '&end=' + endTime + '&role=' + User.get()
    }

    viewDevice () {
      window.open('https://storage.joyway.net/devices')
    }

    uploadExcelData (event: HTMLInputEvent) {
      const files = event.target.files
      if (files != null) {
        const data = new FormData()
        data.append('excel', files[0])

        Http.post<ResExcelBindData>(
          Urls.home_upload,
          data,
          'multipart/form-data'
        ).then(
          (res: ResExcelBindData) => {
            if (res.types === 0 && res.bindDevice === null) {
              // this.showMessage('上传成功')
              this.showMessage(this.$i18n.t('uploadSuc'))
              this.updateData()
            } else {
              this.excelBindData = res
            }
          },
          (err: ResponseData) => {
            this.showMessage(err.Msg)
          }
        )
      }
    }

    showMessage (msg: string) {
      this.messageContent = msg
    }

    loginout () {
      User.set('')
      this.$router.push('/')
    }

    openChart (value: number[], code: string, attr: string) {
      this.chartIds = value
      this.chartCode = code
      this.chartAttr = attr
    }

    closeChart () {
      this.chartIds = []
    }

    closeBind () {
      this.excelBindData = null
    }

    dateFormat (date: Date) {
      return Tool.dateFormat(date)
    }

    setRangeDate () {
      const startPickerInput = document.getElementById(
        'startpicker-input'
      ) as HTMLInputElement
      const startPickerContainer = document.getElementById(
        'startpicker-container'
      ) as HTMLElement

      const endPickerInput = document.getElementById(
        'endpicker-input'
      ) as HTMLInputElement
      const endPickerContainer = document.getElementById(
        'endpicker-container'
      ) as HTMLElement

      const datePicker = DatePicker.createRangePicker({
        language: 'Chinese character',
        startpicker: {
          date: this.tableStartDate,
          input: startPickerInput,
          container: startPickerContainer
        },
        endpicker: {
          date: this.tableEndDate,
          input: endPickerInput,
          container: endPickerContainer
        }
      })
      datePicker.on('change:end', () => {
        this.tableStartDate = datePicker.getStartDate()
        this.tableEndDate = datePicker.getEndDate()
        this.initData(datePicker.getStartDate(), datePicker.getEndDate())
      })
      datePicker.on('change:start', () => {
        this.tableStartDate = datePicker.getStartDate()
        this.tableEndDate = datePicker.getEndDate()
        this.initData(datePicker.getStartDate(), datePicker.getEndDate())
      })
    }

    setAsMainProduct (ids: number[]) {
      const data = {
        focus: ids
      }
      Http.post<null>(Urls.home_important, data).then(() => {
        window.location.href = '/'
      }, (err: ResponseData) => {
        this.showMessage(err.Msg)
      })
    }

    initLanguage () {
      // DatePicker.localeTexts['Chinese character'] = {
      //   titles: {
      //     DD: [
      //       // this.$i18n.t('langs')
      //       '星期日',
      //       '星期一',
      //       '星期二',
      //       '星期三',
      //       '星期四',
      //       '星期五',
      //       '星期六'
      //     ],
      //     D: ['日', '一', '二', '三', '四', '五', '六'],
      //     MMM: [
      //       '1月',
      //       '2月',
      //       '3月',
      //       '4月',
      //       '5月',
      //       '6月',
      //       '7月',
      //       '8月',
      //       '9月',
      //       '10月',
      //       '11月',
      //       '12月'
      //     ],
      //     MMMM: [
      //       '一月',
      //       '二月',
      //       '三月',
      //       '四月',
      //       '五月',
      //       '六月',
      //       '七月',
      //       '八月',
      //       '九月',
      //       '十月',
      //       '十一月',
      //       '十二月'
      //     ]
      //   },
      DatePicker.localeTexts['Chinese character'] = {
        titles: {
          DD: [
            this.$i18n.t('sunday'),
            this.$i18n.t('monday'),
            this.$i18n.t('tuesday'),
            this.$i18n.t('wednesday'),
            this.$i18n.t('thursday'),
            this.$i18n.t('friday'),
            this.$i18n.t('saturday')
          ],
          D: [
            this.$i18n.t('sun'),
            this.$i18n.t('mon'),
            this.$i18n.t('tue'),
            this.$i18n.t('wed'),
            this.$i18n.t('thu'),
            this.$i18n.t('fri'),
            this.$i18n.t('sat')
          ],
          MMM: [
            this.$i18n.t('jan'),
            this.$i18n.t('feb'),
            this.$i18n.t('mar'),
            this.$i18n.t('apr'),
            this.$i18n.t('may1'),
            this.$i18n.t('jun'),
            this.$i18n.t('jul'),
            this.$i18n.t('aug'),
            this.$i18n.t('sep'),
            this.$i18n.t('oct'),
            this.$i18n.t('nov'),
            this.$i18n.t('dec')
          ],
          MMMM: [
            this.$i18n.t('january'),
            this.$i18n.t('february'),
            this.$i18n.t('march'),
            this.$i18n.t('april'),
            this.$i18n.t('may'),
            this.$i18n.t('june'),
            this.$i18n.t('july'),
            this.$i18n.t('august'),
            this.$i18n.t('september'),
            this.$i18n.t('october'),
            this.$i18n.t('november'),
            this.$i18n.t('december')
          ]
        },
        titleFormat: 'yyyy-MMM',
        todayFormat: 'yyyy-MMM-d(DD)'
      }
    }
}
